import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock/news`;

export async function getStockNews(symbols) {
  const query = Array.isArray(symbols) ? symbols.join(",") : String(symbols);
  if (!query.trim()) return [];
  try {
    const res = await apiFetch(`${BASE_URL}?symbols=${encodeURIComponent(query)}`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function getNewsInsights() {
  try {
    const res = await apiFetch(`${BASE_URL}/insights`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
